import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/CTASection.css';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="partnersMeet">
      <div className="partnersMeet__overlay" />

      <div className="partnersMeet__content">
        <div className="partnersMeet__eyebrow">
          Get In Touch
        </div>

        <h2 className="partnersMeet__title">
          Let&apos;s <em>Meet</em>
        </h2>

        <p className="partnersMeet__text">
          For more information about working with ALG Data Guard, give us a call or send us an email.
          We&apos;re here to help in any way.
        </p>

        <button
          className="partnersBtn partnersBtn--orange"
          onClick={() => navigate('/contact')}
        >
          Engage with an Expert
        </button>
      </div>
    </section>
  );
};

export default CTASection;
